import { Loader } from "@/components/ui/loader";

type LoadingDisplayProps = {
  text?: string;
};
export const LoadingDisplay = ({
  text = "Loading... We're almost there.",
}: LoadingDisplayProps) => (
  <div className="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
    <div className="text-center">
      <Loader />
      <h1 className="mt-8 text-2xl font-semibold tracking-tight text-balance sm:text-5xl">
        {text}
      </h1>
    </div>
  </div>
);
